import { gradientGreen } from "@/pages/Standard";


interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}

export const Button = ({ children, onClick, className = "" }: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`
        ${gradientGreen}
        text-white font-semibold py-3 px-12 rounded-[12px]
        text-[17px]
        hover:shadow-lg transition-all duration-300
        active:scale-95
        ${className}
      `}
    >
      {children}
    </button>
  );
};